import { curry, pipe, join, compact, trim } from 'lodash/fp';
/**
 * Joins array of string after filtering out falsy values
 *
 * @param {string} separator - string to be used for joining
 * @param {string[]} input - array of strings to be joined
 *
 * @returns {string} output - final joined string
 *
 * @example
 * smartJoin(' ', ['John', '', undefined, 'Doe'])
 * // returns 'John Doe'
 */

export var smartJoin = curry(function (separator, input) {
  return pipe([compact, join(separator), trim])(input);
});
export default smartJoin;